import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button
} from "@mui/material";

const BestPriceModal = ({ record, downloadFileURL }) => {
  const [open, setOpen] = React.useState(false);
  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = () => {
    const formData = { name, phone };
    console.log("Submitted:", formData); // Replace this with your `onSubmit` logic
    setName("");
    setPhone("");
    handleClose();
  };

  return (
    <>
      {/* Button to open the modal */}
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Attachment
      </Button>

      {/* The modal dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Attachment</DialogTitle>
        <DialogContent dividers>
          {record?.file_data?.map((item,index) => (
            <div>
              <Button
                variant="contained"
                color="primary"
                style={{marginBottom:"10px"}}
                onClick={() => {
                  downloadFileURL(item);
                }}
              >
                Download Attachment {index+1}
              </Button>
            </div>
          ))}
        </DialogContent>
       
      </Dialog>
    </>
  );
};

export default BestPriceModal;
